export default "__VITE_ASSET__1e4099b6__"